// extracted by mini-css-extract-plugin
module.exports = {"button":"Navber_button__2Cd9q","image":"Navber_image__1cTcy","navber":"Navber_navber__Cp6yU"};